import BulkUploadPage from './bulk-upload-page';

export default BulkUploadPage;
